import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavController, LoadingController, MenuController, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';

import { Alert } from '../../services/alert';
import { UserService } from '../../services/user-service';
import { PicFiles, PicService } from '../../services/pic-service';
import { BusinessTasks } from '../../services/business-tasks';

import { MetaTagService } from 'src/app/services/meta-tag-service';
import { ObservableService } from 'src/app/services/observable-service';

@Component({
  selector: 'app-add-business-product',
  templateUrl: './add-business-product.page.html',
  styleUrls: ['./add-business-product.page.scss'],
})
export class AddBusinessProductPage implements OnInit {

  productInfo: {
    url?: string;
    picURL?: string;
    description?: string;
    textMessage?: string;
  } = {};

  isMenuOpen = false

  submitStatus?: string
  errorStatus?: string

  constructor(
    private loadingCtrl: LoadingController,
    private picService: PicService,
    private alert: Alert,
    private observables: ObservableService,
    private changeRef: ChangeDetectorRef,
    public userService: UserService,
    private menuCtrl: MenuController,
    private metaTagService: MetaTagService
  ) {

    const business = this.userService.business

    if (!business) {
      const sub = this.observables.businessFetched.subscribe(() => {
        sub.unsubscribe()
        let eventualLoad = true
        this.loadUIContent(eventualLoad)
      });
      return
    }

    this.loadUIContent()
  }

  ngOnInit() {}

  loadUIContent(eventualLoad?: boolean) {

    this.productInfo = {
    }

    if (eventualLoad) {
      this.changeRef.detectChanges()
    }
  }

  ionViewWillEnter() {
    this.metaTagService.updateTitle('Product')
    this.menuCtrl.enable(true);
  }

  ionViewDidEnter() {
    this.observables.publishSetCurrentMenuRoot('/product-sales')
  }

  openPage(url: string) {
    window.open(url, '_blank')
  }

  addProductImage() {

    const shouldScale = false
    const shouldResize = false
    const showActionSheet = true

    this.picService.getPhoto(shouldScale, shouldResize, showActionSheet, async (files: PicFiles) => {

      const loading = await this.loadingCtrl.create({
        message: 'Sending image'
      })
      loading.present()

      files.pic.save().then((savedFile: any) => {

        loading.dismiss()

        const picURL = savedFile._url
        this.productInfo.picURL = picURL
        this.changeRef.detectChanges()

      }, (errMsg: string) => {
        loading.dismiss()
        this.alert.show('Error', errMsg, 'Ok')
      });

    }, (errorMsg: string) => {
      this.alert.show('Error', errorMsg, 'Ok')
    })
  }


  async submit() {

    this.errorStatus = undefined;
    this.submitStatus = undefined;

    const loading = await this.loadingCtrl.create()
    loading.present()

    BusinessTasks.updateProductInfo(
      this.productInfo,
      () => {

        this.userService.fetch(() => {

          this.submitStatus = 'Updated successfully.'
          loading.dismiss()
          this.changeRef.detectChanges()

        }, (errMsg: string) => {
          this.errorStatus = errMsg
          loading.dismiss()
        })

      },
      (msg: string) => {
        this.errorStatus = msg
        loading.dismiss()
        this.changeRef.detectChanges()
      })
  }

}
